import {
  initialize,
  editBackground
} from './background-removal-sdk';
import {
  fetchImageData,
  fetchGeneratedImageUrl
} from './background-removal-request';

export default {
  API: {
    fetchImageData,
    fetchGeneratedImageUrl
  },
  SDK: {
    initialize,
    editBackground
  }
};
